import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { DID } from 'voxloud-types/dist/models';
import { DidsService } from 'src/app/domains/dids/services';

@Component({
  selector: 'gdp-reactivate-deleted-did-popup',
  templateUrl: './reactivate-deleted-did-popup.component.html',
  styleUrls: ['./reactivate-deleted-did-popup.component.scss']
})
export class ReactivateDeletedDidPopupComponent implements OnInit {
  public did: DID;
  public loading: boolean = false;
  public checkboxesData = {
    value: null,
    isValid: false
  };
  public planAddonHandling: string;
  public companyId: number;
  @Output() onReactivateDid: EventEmitter<string> = new EventEmitter();

  constructor(
    private modal: NgbActiveModal,
    private didsService: DidsService,
  ) { }

  ngOnInit(): void { }

  public onSubmit(): void {
    this.loading = true;
    this.getReactivateObservable().subscribe((res: DID | string) => {
      this.loading = false;
      this.onReactivateDid.emit('company.dids.reactivate-deleted-did.notifications.success');
      this.close();
    }, () => {
      this.loading = false;
      this.close();
    });
  }

  private getReactivateObservable(): Observable<any> {
    return this.planAddonHandling === 'manual' ?
      this.didsService.reactivateDeletedDidManually(this.did.id) :
      this.didsService.reactivateDeletedDid(this.companyId, this.did.id)
  }

  public close(): void {
    this.modal.close('close');
  }
}
